export const SITE_URL = "https://chhikaraconstructions.in";

export const BUSINESS = {
  name: "CHHIKARA CONSTRUCTIONS",
  legalName: "Chhikara Constructions",
  phone: "+918588890900",
  altPhone: "+918572072364",
  email: "chhikaraconstructions@gmail.com",
  street: "D-1, Baraf Khana Road",
  locality: "Jhajjar",
  region: "Haryana",
  postalCode: "124103",
  country: "IN",
  instagram: "https://www.instagram.com/chhikara_constructions",
  // Approximate Jhajjar town-centre coordinates. Replace with the exact
  // "Plus code" latitude/longitude from the Google Business Profile listing so
  // the schema matches the map pin Google already trusts.
  latitude: 28.6063,
  longitude: 76.6564,
  logo: `${SITE_URL}/android-chrome-512x512.png`,
  openingHours: [
    { days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"], opens: "09:00", closes: "18:00" },
    { days: ["Saturday"], opens: "10:00", closes: "16:00" },
  ],
};

/**
 * Towns we actively take work in. Google uses areaServed as a relevance signal
 * for "near me" and "<service> in <town>" queries, so this list should only
 * contain places the business will genuinely travel to.
 */
export const SERVICE_AREAS = [
  "Jhajjar",
  "Rohtak",
  "Bahadurgarh",
  "Beri",
  "Sampla",
  "Kharkhoda",
  "Meham",
  "Kalanaur",
  "Jhajjar District",
  "Rohtak District",
  "Haryana",
  "Delhi NCR",
];

export const absoluteUrl = (path: string): string =>
  path === "/" ? `${SITE_URL}/` : `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;

/**
 * og:image and schema image must be publicly fetchable absolute URLs. CMS
 * images can still resolve to localhost or a bare filename, so anything that
 * is not already https falls back to the logo rather than shipping a link
 * preview that crawlers cannot load.
 */
export const socialImage = (imagePath?: string): string =>
  imagePath && imagePath.startsWith("https://") ? imagePath : BUSINESS.logo;
